class StaticClassifierRepository
{
    movingDirections = {};
    cameraEventSuspiciousStatuses = {};
    auditEventTypes = {};

    constructor() {
        this.movingDirections = { 0 : 'Undefined', 1 : 'In', 2 : 'Out' };

        this.cameraEventSuspiciousStatuses = {
            1 : 'Unknown camera',
            2 : 'Unknown parking zone',
            10 : 'Undefined direction',
            20 : 'IN:IN',
            21 : 'OUT:OUT',
            22 : 'No IN',
            30 : 'Duplicate within same camera set',
        };

        this.auditEventTypes = {
            1 : 'Created',
            2 : 'Deleted',
            10 : 'Checked',
            20 : 'Fine created',
            21 : 'Verification failed',
            22 : 'Fine exported',
            23 : 'Fine export failed',
            30 : 'Daily check started',
            31 : 'Daily check finished'
        };

        this.verificationStatuses = {
            0 : 'None',
            1 : 'New',
            5 : 'Checked',
            6 : 'Fined',
            10 : 'Error',
            11 : 'Zone is not active',
        };
    }

    getAllMovingDirections() {
        return Object.keys(this.movingDirections).map(item => { return { id: item, name: this.movingDirections[item]} });
    }

    getMovingDirectionNameById(id) {
        return this.movingDirections[id];
    }

    getAllCameraEventSuspiciousStatuses() {
        return Object.keys(this.cameraEventSuspiciousStatuses).map(item => { return { id: item, name: this.cameraEventSuspiciousStatuses[item]} });
    }

    getCameraEventSuspiciousStatusNameById(id) {
        return this.cameraEventSuspiciousStatuses[id];
    }

    getAuditEventTypeNameById(id) {
        return this.auditEventTypes[id];
    }

    getVerificationStatusNameById(id) {
        return this.verificationStatuses[id];
    }
}

export default StaticClassifierRepository;
